import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { PAGE_LIMIT } from '../../config';
import { eventSet } from '../../store/eventSlice';
import { filterReset } from '../../store/filterSlice';
import useApiList from '../../hooks/useApiList';
import Loader from '../common/Loader';
import Error from '../common/Error';
import Pager from '../common/Pager';
import EventItem from './EventItem';
import './EventList.css';

const EventList = () => {
	const { t } = useTranslation();
	const dispatch = useDispatch();
	const method = '/events';
	const limit = PAGE_LIMIT;
    const find = '';
    const [ skip, setSkip ] = useState(0);
	const [ data, error, isLoading ] = useApiList({ method, limit, find, skip });

	useEffect(() => {
		dispatch(eventSet(null));
		dispatch(filterReset());
	}, [ dispatch ]);

	return (
		<div className='EventList'>
	    	<h1>{t('events.title')}</h1>

			{isLoading ? <Loader/> :
            <React.Fragment>
                {error ? <Error error={error}/> :
				<React.Fragment>
					{data &&
					<React.Fragment>
					<div className='EventList-list'>
						{data.events.map(event => <EventItem key={event._id} event={event}/>)}
					</div>
					<Pager skip={skip} setSkip={setSkip} limit={limit} total={data.total}/>
					</React.Fragment>}
				</React.Fragment>}
            </React.Fragment>}
		</div>
	);
};

export default EventList;
